
/**
 * 
 * @returns 
* Title Banner for Website used for announcements and welcoming visitors
*/

import React, { useState } from 'react';

//boostrap resources 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Authenticator, AccountSettings, useAuthenticator } from '@aws-amplify/ui-react';

import '../css/AdditionalHelp.css';

export default function Add()
{
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [showChangeEmail, setShowChangeEmail] = useState(false);
    const { user, signOut } = useAuthenticator((context) => [context.user]);

    return(
        <div className='additionalHelpOptions'>
            <h4 className='text-center additionalHelpOptionsTitle'>Additional Options</h4>
            <br></br>
            <Row className='g-2 justify-content-center'>
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        target='_blank'
                        href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'
                    >
                        Update Direct Deposit
                    </Button>
                </Col>
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        onClick={() => setShowChangeEmail(true)}
                    >
                        Change Portal Login 
                    </Button>
                </Col>
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        target='_blank'
                        href='https://applyhousinghelp.mass.gov/s/?language=en_US&LanguageCode=en_US'
                    >
                        Upgrade RAFT Application
                    </Button>
                </Col>
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        target='_blank'
                        href='https://metrohousingboston.zendesk.com/hc/en-us'
                    >
                        Leased Housing Assistance
                    </Button>
                </Col>
            </Row>

            <Row className='g-2 justify-content-center mt-2'>
                {!user && (
                    <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                        <Button
                            variant='primary'
                            size='sm'
                            className='w-50 nav-square-button mx-auto additional-help-button'
                            onClick={() => setShowResetPassword(true)}
                        >
                            Reset Password
                        </Button>
                    </Col>
                )}
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        href='/settings'
                    >
                        View Properties
                    </Button>
                </Col>                
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        href='/faq'
                    >
                        FAQ Help Page
                    </Button>
                </Col>
                <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                    <Button
                        variant='primary'
                        size='sm'
                        className='w-50 nav-square-button mx-auto additional-help-button'
                        target='_blank'
                        href='https://forms.office.com/Pages/ResponsePage.aspx?id=J8xXIgxdK0y6AnOQOwjqAHVPPCEmmcRLu9IABP8zZRBUQlFDU0RFQUxRRjdCTzY4NTZQWjVMS09SVC4u'
                    >
                        Submit Feedback
                    </Button>
                </Col>
                {user && (
                    <Col xs={6} sm={6} lg={3} xl={3} className='text-center nav-button-animate'>
                        <Button
                            variant='primary'
                            size='sm'
                            className='w-50 nav-square-button mx-auto additional-help-button'
                            onClick={signOut}
                        >
                            Log Out
                        </Button>
                    </Col>
                )}
            </Row>

            <br></br>

            <Modal show={showResetPassword} onHide={() => setShowResetPassword(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {user ? (
                        <AccountSettings.ChangePassword />
                    ) : (
                        <Authenticator
                            className='login_container container'
                            initialState="forgotPassword"
                            loginMechanisms={['email']}
                            hideSignUp
                        />
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showChangeEmail} onHide={() => setShowChangeEmail(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Change Portal Login Email Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please send an email to:</p>
                    <p>
                        <strong>Email:</strong>{' '}
                        <a href='mailto:portalhelp@metrohousingboston.org'>portalhelp@metrohousingboston.org</a>
                    </p>
                    <div className='d-flex flex-wrap gap-2'>
                        <Button
                            variant='primary'
                            size='sm'
                            className='buttons'
                            onClick={() => navigator.clipboard?.writeText('portalhelp@metrohousingboston.org')}
                        >
                            Copy Email
                        </Button>
                        <Button
                            variant='primary'
                            size='sm'
                            className='buttons'
                            href='mailto:portalhelp@metrohousingboston.org'
                        >
                            Send Email
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    );
}